<template>
  <div class="item-description">
    <a
      v-if="packageId"
      :href="packagePath"
      class="in-cart-package-link"
    >
      <p class="name"> {{ name }}</p>
    </a>
    <p
      v-else
      class="name"
    >
      {{ name }}
    </p>
    <p class="price">
      {{ price }}
    </p>
    <p class="event-name">
      {{ eventname }}
    </p>
    <p
      v-if="candelete == &quot;true&quot;"
      class="delete"
      @click="deleteOrderItem"
    />

    <div
      v-if="ers"
      class="errors"
    >
      <span>{{ ers }}</span>
      <span
        class="delete"
        @click="ers = null"
      />
    </div>
  </div>
</template>

<script>
/* global locale */
import Api from '../../cart_api'
export default {

  props: ['candelete', 'eventname', 'itemid', 'name', 'price', 'packageId'],

  data() {
    return {
      ers: null,
      updating: false,
      packagePath: `/${locale}/packages/${this.packageId}/path`
    }
  },

  computed: {

  },

  methods: {

    deleteOrderItem() {
      if (this.updating) { return }

      this.ers = null
      this.updating = true
      Api.changeOrderItem(this.itemid, 'DELETE', null).then(item => {
        if (item.errors) { this.ers = item.errors }
        this.updating = false
      })
    }
  }
}
</script>
